<template>
  <div>
    <b-dropdown class="card-drop" toggle-class="p-0" menu-class="dropdown-menu-end" variant="link" v-if="!updating">
      <template v-slot:button-content>
        <div :class="['badge rounded-pill', badgeClass(distress_status)]">
          {{ $t("customer_account_receivables.distress_statuses." + distress_status) }}
          <i class="mdi mdi-chevron-down"></i>
        </div>
      </template>
      <slot name="action" v-bind="{ data }">
        <b-dropdown-item
          v-for="status in statuses"
          :key="status"
          @clickx="$emit('distress-status-selected', item, status)"
          @click="handleUpdate({ ...item, distress_status: status })"
        >
          <div :class="['badge rounded-pill', badgeClass(status)]">
            {{ $t("customer_account_receivables.distress_statuses." + status) }}
          </div>
        </b-dropdown-item>
      </slot>
    </b-dropdown>
    <i v-else class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
  </div>
</template>

<script>
import editable from "@/components/mixins/editable";

export default {
  props: ["item"],
  mixins: [editable],
  data() {
    return {
      statuses: ["healthy", "first_warning", "second_warning", "discontinue"],
      distress_status: this.item.distress_status
    };
  },
  methods: {
    badgeClass(distress_status) {
      const status = {
        healthy: "badge-soft-green-500",
        first_warning: "badge-soft-yellow-500",
        second_warning: "badge-soft-orange-500",
        discontinue: "badge-soft-red-500"
      };
      return status[distress_status];
    },
    update(value) {
      this.distress_status = value.distress_status;
      return this.$axios.put(`/customer_finance_accounts/${value.customer_finance_account_id}`, {
        distress_status: value.distress_status
      });
    },
    updated() {
      this.$emit("updated", { ...this.item, distress_status: this.distress_status });
    }
  }
};
</script>
